import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { IUsersService } from '../../../auxiliary/shared/interfaces/users-service.interface';

@Component({
    selector: 'bv-oauth-callback',
    template: '<div></div>',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AccountOauthCallbackComponent implements OnInit {
  private usersService: IUsersService = inject(IUsersService);

  public ngOnInit(): void {
    this.usersService.completeAuthentication();
  }
}
